// 客户端缓存工具（仿PSP模式）

const CACHE_PREFIX = 'dya_movie_';
const CACHE_EXPIRY = 30 * 24 * 60 * 60 * 1000; // 30天

interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

export function setCache<T>(key: string, data: T): void {
  const entry: CacheEntry<T> = {
    data,
    timestamp: Date.now()
  };
  try {
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify(entry));
  } catch (e) {
    console.warn('Cache write failed:', e);
  }
}

export function getCache<T>(key: string): T | null {
  try {
    const item = localStorage.getItem(CACHE_PREFIX + key);
    if (!item) return null;

    const entry: CacheEntry<T> = JSON.parse(item);

    // 检查是否过期
    if (Date.now() - entry.timestamp > CACHE_EXPIRY) {
      localStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }

    return entry.data;
  } catch (e) {
    console.warn('Cache read failed:', e);
    return null;
  }
}

export function clearCache(): void {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith(CACHE_PREFIX)) {
        localStorage.removeItem(key);
      }
    });
  } catch (e) {
    console.warn('Cache clear failed:', e);
  }
}

// 语义归一化（仿PSP）
export function normalizeQuery(query: string): string {
  return query
    .toLowerCase()
    .trim()
    .replace(/[!?。！？，,.]/g, '')
    .replace(/很|非常|特别|超级|比较|有点|一些/g, '')
    .replace(/的|了|和|与|或者|还是/g, ' ');
}
